import { Button, Dialog } from '../components/ui';
import { strings } from '../strings';
import { DELIVERY_PLATFORMS, LOCATION_TYPES } from './registry';

const s = strings.variables.sourceTypes;

/** "Source types…" (spec 6.10.4, m05 D): both registries with what each entry can do. */
export function SourceTypesDialog({ onClose }: { onClose: () => void }) {
  const example = (type: string) => ({ type, label: type, container: '<name>', secret: false });
  return (
    <Dialog
      title={s.title}
      wide
      onClose={onClose}
      footer={<Button onClick={onClose}>{strings.common.close}</Button>}
    >
      <h3 className="font-semibold">{s.locations}</h3>
      <p className="help mb-2">{s.locationsHelp}</p>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">{s.type}</th>
            <th scope="col">{s.label}</th>
            <th scope="col">{s.secret}</th>
            <th scope="col">{s.limit}</th>
            <th scope="col">{s.versions}</th>
          </tr>
        </thead>
        <tbody>
          {LOCATION_TYPES.map((entry) => {
            const Icon = entry.icon;
            return (
              <tr key={entry.type}>
                <td className="font-mono text-[12px]">
                  <span className="inline-flex items-center gap-1.5">
                    <Icon aria-hidden className="size-3.5" />
                    {entry.type}
                  </span>
                </td>
                <td>{entry.label(example(entry.type))}</td>
                <td>{entry.secret ? strings.common.yes : strings.common.no}</td>
                <td>
                  {entry.limitLabel === strings.variables.limits.generic
                    ? strings.common.dash
                    : entry.limitLabel}
                </td>
                <td className="font-mono text-[12px]">{entry.formatVersion('7f3c21e0a9b14c7d')}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <h3 className="mt-4 font-semibold">{s.deliveries}</h3>
      <p className="help mb-2">{s.deliveriesHelp}</p>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">{s.platform}</th>
            <th scope="col">{s.mode}</th>
            <th scope="col">{s.label}</th>
            <th scope="col">{s.pickup}</th>
            <th scope="col">{s.nowAction}</th>
          </tr>
        </thead>
        <tbody>
          {DELIVERY_PLATFORMS.flatMap((entry) =>
            (['reference', 'plain'] as const).map((mode) => {
              const delivery = {
                platform: entry.platform,
                mode,
                label: '',
                envName: null,
                exposedAsEnv: true,
                secret: true,
                recorded: true,
                pickup: '',
                nowAction: null,
                referenceStatus: 'per-variable' as const,
                refreshReferences: false,
                readersText: null,
                settingsChangeRestarts: true,
              };
              return (
                <tr key={`${entry.platform}:${mode}`}>
                  <td className="font-mono text-[12px]">{entry.platform}</td>
                  <td>{strings.variables.delivery.modes[mode]}</td>
                  <td>{entry.label(mode, delivery)}</td>
                  <td>{entry.pickupText(['web'], delivery)}</td>
                  <td>{entry.nowAction(['web'], delivery)?.label ?? strings.common.dash}</td>
                </tr>
              );
            }),
          )}
        </tbody>
      </table>
      <p className="help mt-3">{s.fallback}</p>
    </Dialog>
  );
}
